import { render, staticRenderFns } from "./VersionTabPanelPage.vue?vue&type=template&id=5c2057a0"
import script from "./VersionTabPanelPage.vue?vue&type=script&lang=js"
export * from "./VersionTabPanelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports